<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Pregunta" />

    <QuestionType />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import QuestionType from "@/components/Pages/Admin/Questions/view.vue";

export default defineComponent({
  name: "CreateQuestionPage",
  components: {
    PageTitle,
    QuestionType,
  },
});
</script>
